"use client";
// LEGACY UI: replace with Collapsible from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import Button from "@casino/legacyUi/SiteButton";

type Props = {
  site: string;
};

const ShowMoreToggle: FC<Props> = ({ children, site }) => {
  const handleToggle = () => {
    document.getElementById("collapsed-container")?.classList.toggle("open");
  };
  return (
    <Button
      className="font-normal"
      variant="tertiary"
      onClick={handleToggle}
      site={site}
    >
      {children}
    </Button>
  );
};

export default ShowMoreToggle;
